import React from "react";
import { pricingPlans } from "../../data/mockData";
import { Check, ArrowRight } from "lucide-react";

const PricingSection = () => {
  return (
    <section id="pricing" className="py-28 relative">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[radial-gradient(ellipse_at_center,_rgba(120,80,200,0.04)_0%,_transparent_70%)]" />

      <div className="relative max-w-[1200px] mx-auto px-6">
        <div className="text-center max-w-xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 bg-white/[0.03] border border-white/[0.07] rounded-full px-4 py-1.5 mb-6">
            <span className="text-[11px] text-[#7a7a7a] uppercase tracking-widest font-medium">Pricing</span>
          </div>
          <h2 className="text-3xl md:text-[2.75rem] font-bold text-white tracking-[-0.02em] leading-tight mb-4">
            Start free. Scale when ready.
          </h2>
          <p className="text-[#666] text-base leading-relaxed">
            No credit card required. Get your library started for free.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 max-w-[960px] mx-auto">
          {pricingPlans.map((plan) => (
            <div
              key={plan.id}
              className={`relative rounded-2xl border p-8 flex flex-col transition-all duration-500 ${
                plan.popular
                  ? "border-white/[0.15] bg-[#0c0c0f] shadow-[0_0_40px_rgba(120,80,200,0.06)]"
                  : "border-white/[0.06] bg-[#0a0a0c] hover:border-white/[0.1]"
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                  <span className="bg-white text-black text-[10px] font-semibold uppercase tracking-widest px-4 py-1 rounded-full">
                    Most Popular
                  </span>
                </div>
              )}

              <div className="mb-6">
                <h3 className="text-white font-semibold text-lg mb-1">{plan.name}</h3>
                <p className="text-[#555] text-[13px] leading-relaxed">{plan.description}</p>
              </div>

              <div className="flex items-baseline gap-1 mb-7">
                <span className="text-4xl font-bold text-white tracking-tight">{plan.price}</span>
                <span className="text-[#555] text-sm">{plan.period}</span>
              </div>

              <a
                href="#signup"
                className={`w-full flex items-center justify-center gap-2 rounded-full py-3 text-sm font-medium transition-all duration-300 mb-8 ${
                  plan.popular
                    ? "bg-white text-black hover:shadow-[0_0_20px_rgba(255,255,255,0.12)]"
                    : "border border-white/[0.1] text-white/80 hover:text-white hover:border-white/[0.2] hover:bg-white/[0.03]"
                }`}
              >
                {plan.cta}
                <ArrowRight size={14} />
              </a>

              <div className="space-y-3 flex-1">
                {plan.features.map((feature, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-4.5 h-4.5 rounded-full flex items-center justify-center shrink-0">
                      <Check size={13} className={plan.popular ? "text-emerald-400/80" : "text-white/25"} />
                    </div>
                    <span className="text-[13px] text-[#777]">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
